<template>
  <el-container>
    <el-main>
      <el-row>
        <el-col :span="20">
          <el-form :model="filterData" :inline="true">
            <el-form-item>
              <el-input v-model="filterData.tenant" placeholder="物业名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="filterData.order_no" placeholder="订单号"></el-input>
            </el-form-item>
            <el-form-item>
              <el-date-picker v-model="filterData.daterange" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSearch">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-table :data="records" border>
        <el-table-column label="物业名称" prop="name"></el-table-column>
        <el-table-column label="订单号" prop="order_no"></el-table-column>
        <el-table-column label="订单类型" prop="type"></el-table-column>
        <el-table-column label="支付时间" prop="payed_at"></el-table-column>
        <el-table-column label="支付金额" prop="payment">
          <template slot-scope="scope">
            ￥{{ scope.row.payment }}
          </template>
        </el-table-column>
        <el-table-column label="分佣比例" prop="ratio">
          <template slot-scope="scope">
            {{ scope.row.ratio }}%
          </template>
        </el-table-column>
        <el-table-column label="佣金" prop="commission">
          <template slot-scope="scope">
            ￥{{ scope.row.commission }}
          </template>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'Settlements',
  data () {
    return {
      filterData: {
        tenant: '',
        order_no: '',
        daterange: []
      },
      records: []
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList() {
      request.get('commissions').then(res=>{
        this.records = res.data
      })
    },
    onSearch() {
      this.getList()
    },
    check (row) {
      this.$confirm(`确定该物业${row.month}月度账单已结算了吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '修改成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消修改'
        })
      })
    }
  }
}
</script>

<style scoped>
.el-aside {
  border-right: 1px solid #ddd;
}
.list-group li {
  cursor: pointer;
  padding: 0 10px;
}
.list-group li:hover, .list-group li.active {
  background-color: #ecf5ff;
}
</style>
